export default "__VITE_ASSET__QCVX4Pwr__"